export default __webpack_public_path__ + "static/media/1945.1bc68be8.png";